import { RESET_COMPLETE_TASK, TASKS_LIST, TASK_DETAILS, TOGGLE_COMPLETE_TASK, UPDATE_TASK } from './types';

const initialState = {
  taskList: {
    loading: false,
    data: [],
    count: 0,
    error: null
  },
  taskDetails: {
    loading: false,
    data: null,
    error: null
  },
  completeTask: {
    loading: false,
    error: null,
    success: false
  },
  updateTaskAction: {
    loading: false,
    error: null,
    success: false
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // Tasks List
    case TASKS_LIST.pending:
      return {
        ...state,
        taskList: { ...state.taskList, loading: true, error: null }
      };
    case TASKS_LIST.success: {
      const payload = action.payload?.data || action.payload;
      const data = payload?.results
        || (Array.isArray(payload) ? payload : []);
      const count = payload?.count || 0;
      return {
        ...state,
        taskList: {
          ...state.taskList,
          loading: false,
          data,
          count
        }
      };
    }
    case TASKS_LIST.error:
      return {
        ...state,
        taskList: { ...state.taskList, loading: false, error: action.payload }
      };

    // Task Details
    case TASK_DETAILS.pending:
      return {
        ...state,
        taskDetails: { ...state.taskDetails, loading: true, error: null, data: null }
      };
    case TASK_DETAILS.success: {
      const data = action.payload?.data || action.payload;
      return {
        ...state,
        taskDetails: { ...state.taskDetails, loading: false, data }
      };
    }
    case TASK_DETAILS.error:
      return {
        ...state,
        taskDetails: { ...state.taskDetails, loading: false, error: action.payload }
      };

    // Toggle Complete
    case TOGGLE_COMPLETE_TASK.pending:
      return {
        ...state,
        completeTask: { ...state.completeTask, loading: true, error: null, success: false }
      };
    case TOGGLE_COMPLETE_TASK.success:
      return {
        ...state,
        completeTask: { ...state.completeTask, loading: false, success: true, error: null }
      };
    case TOGGLE_COMPLETE_TASK.error:
      return {
        ...state,
        completeTask: { ...state.completeTask, loading: false, error: action.payload }
      };
    case RESET_COMPLETE_TASK:
      return {
        ...state,
        completeTask: { ...initialState.completeTask }
      };

    // Update Task
    case UPDATE_TASK.pending:
      return {
        ...state,
        updateTaskAction: { ...state.updateTaskAction, loading: true, error: null, success: false }
      };
    case UPDATE_TASK.success:
      return {
        ...state,
        updateTaskAction: { ...state.updateTaskAction, loading: false, success: true }
      };
    case UPDATE_TASK.error:
      return {
        ...state,
        updateTaskAction: { ...state.updateTaskAction, loading: false, error: action.payload }
      };

    default:
      return state;
  }
};

export default reducer;
